export const ENROLL_SPECIFIC_MFA = 'ENROLL_SPECIFIC_MFA';
export const CLEAR_MFA_ENROLL_ERROR = 'CLEAR_MFA_ENROLL_ERROR'


